var exports = {
  "Showcase": "Showcase__NfEUYA",
  "Showcase__firstElement": "Showcase__firstElement__KGopob",
  "Showcase__header": "Showcase__header__pF-JZe",
  "showcase-header-enter": "showcase-header-enter__Q9_Md9",
  "Showcase__hero": "Showcase__hero__NBW2-k",
  "Showcase__actions": "Showcase__actions__qqddJ6",
  "Showcase__action": "Showcase__action__4Drxp3",
  "Showcase__downloadMenu": "Showcase__downloadMenu__C7YCam",
  "Showcase__videoContainer": "Showcase__videoContainer__5JIjQi",
  "Showcase__playback": "Showcase__playback__KHOx54",
  "Showcase__description": "Showcase__description__qfVCUq",
  "Showcase__media": "Showcase__media__YyDmxE",
  "Showcase__video": "Showcase__video__NrmV7-",
};

__webpack_require__.r(module.exports = exports);
